import debounce from 'lodash/debounce';

const DEBOUNCE_WAIT = 1000;

export default function searchDebounce(func, time = false) {
  if (time) {
    return debounce(func, time);
  }

  return debounce(func, DEBOUNCE_WAIT);
}
